<div class="row">
  <div class="col-12">
    <div class="tile text-center text-size-xl">
      {{ 'contract-confirmation.reminder.header' | transloco }}
      <div>
        <a class="link-secondary cursor-pointer text-default" (click)="service.displayDialog()">
          {{ 'contract-confirmation.reminder.link' | transloco }}
        </a>
      </div>
    </div>
  </div>
</div>
